module.exports = __webpack_public_path__ + "static/opener-text-sml-cfa4d979a5560d77453293649d88e308.png";